module.exports = __webpack_public_path__ + "static/media/transparentHQ.781d8be5.png";